/* global SideDrawer */

class WishlistDrawer extends SideDrawer {
  connectedCallback() {
    this.listEl = this.querySelector('[data-wishlist-list]');
    this.mainEl = this.querySelector('[data-wishlist-main]');
    this.emptyEl = this.querySelector('[data-wishlist-empty]');
    this.countEl = this.querySelector('[data-wishlist-count]');

    this.handleOpenEvent = this.handleOpenEvent.bind(this);
    this.handleListClick = this.handleListClick.bind(this);

    document.addEventListener('dispatch:wishlist-drawer:open', this.handleOpenEvent);
    this.listEl?.addEventListener('click', this.handleListClick);
    this.moreSwatchesTemplate = this.getAttribute('data-more-swatches-template') || '';
    this.renderFromStorage();
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:wishlist-drawer:open', this.handleOpenEvent);
    this.listEl?.removeEventListener('click', this.handleListClick);
  }

  handleOpenEvent(evt) {
    this.renderFromStorage();
    this.open(evt.detail ? evt.detail.opener : null);
  }

  getItems() {
    try {
      const raw = window.localStorage.getItem('wishlist_product_items');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  setItems(items) {
    try {
      window.localStorage.setItem('wishlist_product_items', JSON.stringify(items));
    } catch (e) {
      /* ignore */
    }
  }

  setEmptyState(isEmpty) {
    if (this.mainEl) {
      this.mainEl.classList.toggle('cart-drawer__content--hidden', isEmpty);
    }
    if (this.emptyEl) {
      this.emptyEl.classList.toggle('cart-drawer__empty-content--hidden', !isEmpty);
    }
  }

  escapeHtml(str) {
    if (str == null || str === '') return '';
    const div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  escapeAttr(str) {
    return this.escapeHtml(str).replace(/"/g, '&quot;');
  }

    renderSwatches(item) {
    const swatches = item.swatches;
    if (!Array.isArray(swatches) || !swatches.length) return '';

    // 与 product-block 竖版卡片一致（card_layout portrait 时 option_limit = 3）
    const OPTION_LIMIT = 3;

    const optionName = this.escapeAttr(item.swatch_option_name || '');
    const blocks = swatches
      .map((s, i) => {
        if (!s || !s.label) return '';

        const label = this.escapeHtml(s.label);
        const labelAttr = this.escapeAttr(s.label);
        const classes = ['product-block-options__item'];
        if (s.selected) classes.push('product-block-options__item--selected');
        if (s.available === false) classes.push('product-block-options__item--unavailable');
        // 与 product-block：forloop.index > option_limit → truncated（默认隐藏，整组 hover 展开）
        if (i + 1 > OPTION_LIMIT) classes.push('product-block-options__item--truncated');

        let attrs = `class="${classes.join(' ')}" data-option-item="${labelAttr}"`;

        if (s.media_id) {
          attrs += ` data-media="${this.escapeAttr(String(s.media_id))}"`;
        }

        // 优先用 swatch_key 匹配 swatches.css.liquid 里的 CSS 颜色定义
        const swatchKey = s.swatch_key || (s.label ? String(s.label).toLowerCase().trim() : null);
        if (swatchKey) {
          attrs += ` data-swatch="${this.escapeAttr(swatchKey)}"`;
        }

        // 有 RGB 时用内联样式（native swatch）
        if (s.rgb) {
          attrs += ` style="--swatch-background-color: rgb(${this.escapeAttr(String(s.rgb))})"`;
        }

        // 存入 variant 图片 URL，供点击切换产品图使用
        const imgSrc = s.variant_image || s.native_image || s.image || null;
        if (imgSrc) {
          attrs += ` data-image="${this.escapeAttr(imgSrc)}"`;
        }

        // 只显示纯色圆圈，不显示衣服图片
        const inner = `<span class="product-block-options__item__text">${label}</span>`;

        return `<span ${attrs}>${inner}</span>`;
      })
      .filter(Boolean)
      .join('');

    let moreHtml = '';
    if (swatches.length > OPTION_LIMIT) {
      const remaining = swatches.length - OPTION_LIMIT;
      const tpl = this.moreSwatchesTemplate || `+ ${remaining} more`;
      const moreLabel = tpl.includes('__COUNT__')
        ? tpl.replace(/__COUNT__/g, String(remaining))
        : tpl;
      moreHtml = `<span class="product-block-options__more-label">${moreLabel}</span>`;
    }

    return `
      <div class="product-block-options product-block-options--swatch" data-option-name="${optionName}">
        <div class="product-block-options__inner">${blocks}${moreHtml}</div>
      </div>`;
  }

  syncGlobalUi() {
    if (typeof window.syncWishlistButtonsFromStorage === 'function') {
      window.syncWishlistButtonsFromStorage();
      return;
    }
    const items = this.getItems();
    const idSet = new Set(items.map((it) => String(it.id)));
    document.querySelectorAll('.product-wishlist-btn').forEach((btn) => {
      const id = btn.getAttribute('data-product-id');
      if (!id) return;
      btn.classList.toggle('is-active', idSet.has(String(id)));
    });
    document.querySelectorAll('[data-wishlist-count-header]').forEach((el) => {
      el.textContent = items.length > 0 ? String(items.length) : '';
    });
  }

  handleListClick(e) {
    // 移除按钮（心形）
    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const id = removeBtn.getAttribute('data-product-id');
      if (!id) return;
      const next = this.getItems().filter((it) => String(it.id) !== String(id));
      this.setItems(next);
      this.syncGlobalUi();
      this.renderFromStorage();
      return;
    }

    // 色块点击：切换产品图
    const swatchItem = e.target.closest('.product-block-options__item[data-image]');
    if (swatchItem) {
      e.preventDefault();
      e.stopPropagation();

      const imgUrl = swatchItem.getAttribute('data-image');
      const article = swatchItem.closest('.wishlist-drawer-item');
      if (!imgUrl || !article) return;

      // 更新产品图
      const img = article.querySelector('.wishlist-drawer-item__image img');
      if (img) img.src = imgUrl;

      // 更新选中状态
      article.querySelectorAll('.product-block-options__item').forEach((el) => {
        el.classList.remove('product-block-options__item--selected');
      });
      swatchItem.classList.add('product-block-options__item--selected');
    }
  }

  renderFromStorage() {
    const items = this.getItems();

    if (!this.listEl) return;

    if (!items.length) {
      this.listEl.innerHTML = '';
      this.setEmptyState(true);
      if (this.countEl) this.countEl.textContent = '';
      return;
    }

    this.setEmptyState(false);
    if (this.countEl) this.countEl.textContent = `(${items.length})`;

    const heartSvg = `<svg class="product-wishlist-btn__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42
               4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81
               14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4
               6.86-8.55 11.54L12 21.35z" />
    </svg>`;

    this.listEl.innerHTML = items
      .map((item) => {
        const id = this.escapeAttr(item.id);
        const url = this.escapeAttr(item.url || '#');
        const title = this.escapeHtml(item.title || '');
        const imgHtml = item.image
          ? `<img src="${this.escapeAttr(item.image)}" alt="${title}" loading="lazy">`
          : '';
        const priceHtml = item.price_html || '';
        const swatchesHtml = this.renderSwatches(item);

        return `
      <article class="wishlist-drawer-item">
        <button type="button" class="product-wishlist-btn is-active wishlist-drawer-item__remove" data-wishlist-remove data-product-id="${id}" aria-label="Remove from wishlist">
          ${heartSvg}
        </button>
        <a href="${url}" class="wishlist-drawer-item__image">${imgHtml}</a>
        <a href="${url}" class="wishlist-drawer-item__title">${title}</a>
        <div class="wishlist-drawer-item__price">${priceHtml}</div>
        ${swatchesHtml ? `<div class="wishlist-drawer-item__swatches">${swatchesHtml}</div>` : ''}
      </article>`;
      })
      .join('');

    // 自动补全旧数据：用页面上已有的按钮属性更新 localStorage 里缺失的 price_html
    this.refreshStaleItemsFromPage();
    // 针对页面上没有的商品，通过 AJAX 拉取价格
    this.refreshStaleItemsFromApi();
  }

  // 用当前页面上的 wishlist 按钮属性刷新旧 localStorage 数据
  refreshStaleItemsFromPage() {
    const items = this.getItems();
    let updated = false;

    document.querySelectorAll('.product-wishlist-btn[data-product-id]').forEach((btn) => {
      const id = btn.getAttribute('data-product-id');
      const item = items.find((it) => String(it.id) === String(id));
      if (!item) return;

      const priceHtml = btn.getAttribute('data-product-price-html') || '';
      if (!item.price_html && priceHtml) {
        item.price_html = priceHtml;
        updated = true;
      }

      const swatchesRaw = btn.getAttribute('data-product-swatches') || '';
      if ((!item.swatches || !item.swatches.length) && swatchesRaw) {
        try {
          const parsed = JSON.parse(swatchesRaw);
          if (Array.isArray(parsed) && parsed.length) {
            item.swatches = parsed;
            updated = true;
          }
        } catch (e) { /* ignore */ }
      }
    });

    if (updated) {
      this.setItems(items);
      // 重新渲染但不触发再次刷新（防止死循环）
      this._renderOnly();
    }
  }

  // 通过 Shopify AJAX API 为缺少 price_html 的商品拉取价格
  refreshStaleItemsFromApi() {
    const items = this.getItems();
    const stale = items.filter((it) => !it.price_html && it.url);
    if (!stale.length) return;

    stale.forEach((item) => {
      const urlPath = (item.url || '').split('?')[0];
      const handle = urlPath.replace(/^.*\/products\//, '');
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then((r) => r.json())
        .then((product) => {
          const latest = this.getItems();
          const target = latest.find((it) => String(it.id) === String(item.id));
          if (!target) return;

          let changed = false;
          if (!target.price_html && product.price) {
            const moneyFormat = window.Shopify && window.Shopify.money_format
              ? window.Shopify.money_format
              : '${{amount}}';
            const amount = (product.price / 100).toFixed(2);
            target.price_html = `<span class="price__regular"><span class="price-item price-item--regular">${moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(product.price / 100))}</span></span>`;
            changed = true;
          }

          if (changed) {
            this.setItems(latest);
            this._renderOnly();
          }
        })
        .catch(() => { /* ignore */ });
    });
  }

  // 仅重新渲染 HTML，不触发刷新逻辑（供内部调用）
  _renderOnly() {
    const items = this.getItems();
    if (!this.listEl || !items.length) return;

    const heartSvg = `<svg class="product-wishlist-btn__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42
               4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81
               14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4
               6.86-8.55 11.54L12 21.35z" />
    </svg>`;

    this.listEl.innerHTML = items
      .map((item) => {
        const id = this.escapeAttr(item.id);
        const url = this.escapeAttr(item.url || '#');
        const title = this.escapeHtml(item.title || '');
        const imgHtml = item.image
          ? `<img src="${this.escapeAttr(item.image)}" alt="${title}" loading="lazy">`
          : '';
        const priceHtml = item.price_html || '';
        const swatchesHtml = this.renderSwatches(item);

        return `
      <article class="wishlist-drawer-item">
        <button type="button" class="product-wishlist-btn is-active wishlist-drawer-item__remove" data-wishlist-remove data-product-id="${id}" aria-label="Remove from wishlist">
          ${heartSvg}
        </button>
        <a href="${url}" class="wishlist-drawer-item__image">${imgHtml}</a>
        <a href="${url}" class="wishlist-drawer-item__title">${title}</a>
        <div class="wishlist-drawer-item__price">${priceHtml}</div>
        ${swatchesHtml ? `<div class="wishlist-drawer-item__swatches">${swatchesHtml}</div>` : ''}
      </article>`;
      })
      .join('');
  }
}

window.customElements.define('wishlist-drawer', WishlistDrawer);